module.exports = __webpack_public_path__ + "img/banker-filled.d2781006.svg";